import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { instituteQueryKeys, updateInstitute } from '../api/institutes.api';
import type { UpdateInstitutePayload } from '../types/institute.types';

export function useUpdateInstitute(id: number, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateInstitutePayload) => updateInstitute(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: instituteQueryKeys.all() });
      toast.success('Institute updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update institute');
    },
  });
}
